import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { EventService } from '@core/services/event.service';

@Component({
	selector: 'ifective-no-connection',
	templateUrl: './no-connection.component.html',
	styleUrls: ['./no-connection.component.scss']
})
export class NoConnectionComponent implements OnInit {

	constructor(
		private eventService: EventService,
		private modalService: NgbModal,
		private location: Location
	) {
		this.modalService.dismissAll();
	}

	ngOnInit() {

		this.eventService.getConnected().subscribe(() => this.retryConnection());
	}

	retryConnection() {

		this.location.back();
	}
}